import { Card, Grid, Link } from "@postenbring/hedwig-react";

export const MiniatureCards = ({ cards, span, theme, dataColor }) => (
    <Grid gap="12-16" span={span} className="hds-mb-20-24">
        {cards.map((card, index) => (
            <Card key={index} variant="miniature" data-color={dataColor} theme={theme}>
                {card.imgUrl && (
                    <Card.Media>
                        <Card.MediaImg src={card.imgUrl} alt={card.imgAltText} />
                    </Card.Media>
                )}
                <Card.Body>
                    {card.title && (
                        <Card.BodyHeader as="h3">
                            <Card.BodyHeaderTitle>
                                {card.title} {card.color}
                            </Card.BodyHeaderTitle>
                        </Card.BodyHeader>
                    )}
                    {card.description && (
                        <Card.BodyDescription>{card.description}</Card.BodyDescription>
                    )}
                    <Card.BodyAction asChild>
                        <Link href={card.url} variant="solid" target={card.newTab ? "_blank" : ""}>
                            <Card.BodyActionArrow direction={card.arrowDirection} />
                            {card.linkText}
                        </Link>
                    </Card.BodyAction>
                </Card.Body>
            </Card>
        ))}
    </Grid>
);
